import type { SelectSize } from './types'

export const cx = (...classes: Array<string | false | null | undefined>) => classes.filter(Boolean).join(' ')

export const selectButtonSizeClassMap: Record<SelectSize, string> = {
  sm: 'h-9 text-xs',
  md: 'h-11 text-sm font-medium',
}

